import React, { useSyncExternalStore } from "react";
import Loader from "react-js-loader";
import loader from "../../assets/images/loder.gif";
import {
  getPendingApiRequests,
  subscribeToApiLoading,
} from "../apiServices/allApi";
import "../../assets/css/Spinner.css";

export function Spinner() {
  return (
    <div className="admin-loader-overlay" role="status" aria-live="polite">
      <div className="item dashboaed_loader">
        <Loader
          type="bubble-ping"
          bgColor={"#fff"}
          title={<img src={loader} alt="Loading..." />}
          color={"#000"}
          size={100}
        />
      </div>
    </div>
  );
}

export function ApiLoadingOverlay() {
  const pendingRequests = useSyncExternalStore(
    subscribeToApiLoading,
    getPendingApiRequests,
    getPendingApiRequests,
  );

  return pendingRequests > 0 ? <Spinner /> : null;
}

export default Spinner;
